
export class Coach {
  _id: string;
  teamId: string;
  first_name: string;
  last_name: string;
  gender: string;
  profile_image?: string;
  isimagechanged?: boolean;
}
